import "./Icon_module.css";
const Icon_module = {
    icon: "icon__0e84c22c58ab0ae9"
};
export { Icon_module as default };
